import { render, staticRenderFns } from "./PaysWages.vue?vue&type=template&id=0e97e17e&scoped=true&"
import script from "./PaysWages.vue?vue&type=script&lang=js&"
export * from "./PaysWages.vue?vue&type=script&lang=js&"
import style0 from "./PaysWages.vue?vue&type=style&index=0&id=0e97e17e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e97e17e",
  null
  
)

export default component.exports